import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import {
  QueryReturnValue,
  TAPIResponseStatus,
} from '~/api/baseFetch/common.type';

type oneBoxV2APIResponse<T> = {
  status: TAPIResponseStatus;
  data: T;
};

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_NOTIFICATION_MANAGE_API,
  method: 'GET',
});

export const oneBoxV2FetchBase: BaseQueryFn = async (
  args: string | FetchArgs,
  api,
  extraOptions,
) => {
  const result = (await baseQuery(args, api, extraOptions)) as QueryReturnValue<
    oneBoxV2APIResponse<unknown>,
    FetchBaseQueryError,
    FetchBaseQueryMeta
  >;

  return result;
};
